module.exports = __webpack_public_path__ + "static/img/pc_01.25642c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/A3/pc_01.png
// module id = 0r5z
// module chunks = 0